import { Input, InputRef } from 'antd';
import { forwardRef } from 'react';
import styled from 'styled-components';

interface Props {
  value?: string;
  onChange?: (value: string) => void;
}

type Ref = InputRef;

const InputCateGoryName = forwardRef<Ref, Props>(({ value, onChange }: Props, ref) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    onChange?.(newValue);
  };

  return (
    <Container>
      <Input
        style={{
          height: '80px',
          alignItems: 'center',
          borderRadius: '4px',
          background: '#fff',
          fontSize: '32px',
        }}
        value={value}
        onChange={handleChange}
        ref={ref}
        autoFocus
        allowClear={{
          clearIcon: <BackWordIcon />,
        }}
        placeholder="Enter category name"
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        inputMode="text"
      />
    </Container>
  );
});

InputCateGoryName.displayName = 'InputCateGoryName';

export default InputCateGoryName;

const Container = styled.div`
  input {
    text-align: center;
    color: #1d2129;
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 0 12px;
  }
`;

const BackWordIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='41' height='41' viewBox='0 0 41 41' fill='none'>
    <path d='M11.8421 10.75H36.5703V30.75H11.8421L4.07031 20.75L11.8421 10.75Z' fill='#86909C' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M28.7562 14.8915C29.2444 15.3797 29.2444 16.1711 28.7562 16.6593L18.5992 26.8163C18.1111 27.3045 17.3196 27.3045 16.8314 26.8163C16.3433 26.3281 16.3433 25.5367 16.8314 25.0485L26.9885 14.8915C27.4766 14.4034 28.2681 14.4034 28.7562 14.8915Z'
      fill='#86909C'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.8314 14.8915C17.3196 14.4034 18.1111 14.4034 18.5992 14.8915L28.7562 25.0485C29.2444 25.5367 29.2444 26.3281 28.7562 26.8163C28.2681 27.3045 27.4766 27.3045 26.9885 26.8163L16.8314 16.6593C16.3433 16.1711 16.3433 15.3797 16.8314 14.8915Z'
      fill='#86909C'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M28.7562 14.8915C29.2444 15.3797 29.2444 16.1711 28.7562 16.6593L18.5992 26.8163C18.1111 27.3045 17.3196 27.3045 16.8314 26.8163C16.3433 26.3281 16.3433 25.5367 16.8314 25.0485L26.9885 14.8915C27.4766 14.4034 28.2681 14.4034 28.7562 14.8915Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.8314 14.8915C17.3196 14.4034 18.1111 14.4034 18.5992 14.8915L28.7562 25.0485C29.2444 25.5367 29.2444 26.3281 28.7562 26.8163C28.2681 27.3045 27.4766 27.3045 26.9885 26.8163L16.8314 16.6593C16.3433 16.1711 16.3433 15.3797 16.8314 14.8915Z'
      fill='white'
    />
  </svg>
);
